import Util from '@/lib/util'
export default [
    {
        title:Util.L('Code'),
        width : 150,
        key:'code'
    },
     {
        title:Util.L('Name'),
        width : 200,
        key:'name'
    },
    {
        title:Util.L('ParentCategory'),
        width : 200,
        key:'parentCode'
    },
    {
        title:Util.L('CreationTime'),
        width : 200,
        key:'creationTime',
        render:(h:any,params:any)=>{
           return h("span", Util.toViewDateString(params.row.creationTime));
        }
    }]
